import {
    HomeIcon,
    UserGroupIcon,
    ChartBarIcon,
    MagnifyingGlassIcon,
    SparklesIcon
} from '@heroicons/react/24/outline'

export const NAV_TITLE_HOMEPAGE = 'Homepage'
export const NAV_TITLE_CONTENT_SEARCH = 'Comment search'
export const NAV_TITLE_ASK_ARWEN = 'Ask Arwen'
export const NAV_TITLE_TEAM = 'Team'
export const NAV_TITLE_REPORT = 'Reporting'

// Support and About are utility surfaces, not core product pages, so they live in
// the sidebar foot beside Admin (see Sidebar.tsx) rather than in this main list.
export function getNavigationItems(
    onHomePage: boolean,
    onContentSearchPage: boolean,
    onTeamPage: boolean,
    onReportPage: boolean,
    onAskArwenPage: boolean = false
) {
    return [
        {
            name: NAV_TITLE_HOMEPAGE,
            href: '#',
            icon: HomeIcon,
            current: onHomePage
        },
        {
            name: NAV_TITLE_CONTENT_SEARCH,
            href: '#/content-search',
            icon: MagnifyingGlassIcon,
            current: onContentSearchPage
        },
        {
            name: NAV_TITLE_ASK_ARWEN,
            href: '#/ask-arwen',
            icon: SparklesIcon,
            current: onAskArwenPage
        },
        {
            // EN-327: shows a holding page for every user while we move to Monthly
            // Moderation Reports, so it's not gated on dashboardEnabled.
            name: NAV_TITLE_REPORT,
            href: '#/report',
            icon: ChartBarIcon,
            current: onReportPage
        },
        {
            name: NAV_TITLE_TEAM,
            href: '#/team',
            icon: UserGroupIcon,
            current: onTeamPage
        }
    ]
}
